import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnDestroy {
    pageTitle: string;
    mobileQuery: MediaQueryList;

    @ViewChild('sidenav') sidenav!: MatSidenav;

    private mobileQueryListener: () => void;

    constructor(changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, router: Router, activatedRoute: ActivatedRoute) {
        this.mobileQuery = media.matchMedia('(max-width: 1280px)');
        this.mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this.mobileQueryListener);
        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.pageTitle = activatedRoute.firstChild.snapshot.data.title;
            }
        });
    }

    toggleSidenav(): void {
        this.sidenav.toggle();
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this.mobileQueryListener);
    }
}
